/* eslint-disable */
import { Component, ViewEncapsulation } from "@angular/core";
import { FieldType, FormlyFieldConfig } from "@ngx-formly/core";

@Component({
    selector: "formly-field-tabs",
    template: `
        <mat-tab-group>
            <mat-tab
                *ngFor="let tab of field.fieldGroup; let i = index; let last = last"
                [label]="tab.templateOptions.label"
            >
                <ng-template matTabContent>
                    <formly-field [field]="tab"></formly-field>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    `,
    styleUrls: ["./tabs.type.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class FormlyFieldTabs extends FieldType {
    isValid(field: FormlyFieldConfig) {
        if (field.key) {
            return field.formControl.valid;
        }

        return field.fieldGroup ? field.fieldGroup.every((f) => this.isValid(f)) : true;
    }
}
